import $ from 'jquery';
import {showFormResponse} from '../common/json-response';
import {setSaveButtonActive, setSaveButtonDisabled} from './appraisal-save-button-toggle'

// убираем предыдущие сообщения
const formStatusMessages = document.querySelector('.action-status-messages');
const fieldsStatusMessages = document.querySelectorAll('.field-action-status-messages');

let form;
let fieldsData = {};

function getFieldsData() {
    const fields = form.querySelectorAll('.send-field');

    fields.forEach(input => {
      fieldsData[input.name] = input.value;
    });

    return fieldsData;
}

function initAppraisalJudgingSave() {
  const saveBtn = document.querySelector('#appraisalJudgingSaveBtn');
  form = document.querySelector('#appraisal_judging_block .work_judging_form');

  if (!saveBtn || !form) {
    return;
  }

  saveBtn?.addEventListener('click', function (e) {
    e.preventDefault();
    setSaveButtonDisabled(saveBtn);

    // убираем предыдущие сообщения
    formStatusMessages.innerHTML = '';
    fieldsStatusMessages.forEach((field) => {
      field.innerHTML = '';
    });

    fieldsData = getFieldsData();
    const url = form.getAttribute('action');

    $.ajax({
      type: "POST",
      url: url,
      dataType: 'json',
      data: fieldsData,
      success: function (data) {
        if (data.redirectTo?.length) {
          window.location.href = data.redirectTo;
        }

        showFormResponse(data);
        setSaveButtonActive(saveBtn);
      },
      error: function (data) {
        showFormResponse(data);
        setSaveButtonActive(saveBtn);
      },
    });
  });
}

export { initAppraisalJudgingSave }
